import { fromJS } from 'immutable';
import { actionTypes } from 'modules/booking/constants';

const initialEventServicesState = fromJS({
  list: [],
  isLoading: false,
});

export const eventServicesReducer = (state = initialEventServicesState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EVENT_SERVICES_LOADING:
      return state.set('isLoading', action.payload);
    case actionTypes.FETCH_EVENT_SERVICES:
      return state.set('list', fromJS(action.payload));
    case actionTypes.RESET_EVENT_SERVICES:
      return initialEventServicesState;
    default:
      return state;
  }
};
